import { api } from "../api";

/**
 * deviceFindAllExportResponse - Function that finds on database all devices by status and export in a PDF/XSLX file  
 * /devices/{status}/{exportType}  
 * method GET  
 * @async-function
 */
const deviceFindAllExportResponse = async (token: string, managerId: number, status: string, exportType: string, simpleXlsxExport = false) => {
    const response = await api.get(
        `/devices/${managerId}/${status}/${exportType}/export?simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default deviceFindAllExportResponse;